<section class="deliveryTagSaver-wrapper">
	<a class="deliveryTagSaver" [href]="deliverySubscriptionPlansPath" target="_blank">
		<div>
			<h5>Get unlimited deliveries</h5>
			<span
				>from {{ (deliverySubscriptionBasePlan$ | async)?.price | currency: 'NZD':'symbol-narrow':'1.2-2' }} per
				month</span
			>
		</div>
		<div class="left-align">
			<cdx-svg-icon name="chevron-right" fill="green" size="extra-small"></cdx-svg-icon>
		</div>
	</a>
</section>
